import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getProgramSlug } from '../../../selectors/getProgramSlug';
import { Pages } from '../../../contexts/Location/LocationContext';
import { locationProviderPropsMap } from '../../../contexts/Location/locationProviderPropsMap';
import { IChallengeContext } from '../../../contexts/storage-contexts/Challenge';

export const goToVisitorPage = ({
  challengeData,
  flowAPI,
}: {
  challengeData: IChallengeContext['challengeData'];
  flowAPI: ControllerFlowAPI;
}) => {
  const slug = getProgramSlug(challengeData?.challenge);
  if (!slug) {
    return;
  }

  const location = locationProviderPropsMap(flowAPI);

  return location.goToPage({
    pageId: Pages.Details,
    challengeId: slug,
  });
};
